import classNames from 'classnames';
import React, { forwardRef, createContext } from 'react';

import Type from '../Type/Type';
import * as styles from './Section.module.scss';

export const themes = {
  DEFAULT: 'themeDefault',
  ALTERNATE: 'themeAlternate',
  NAVY: 'themeNavy',
  TAN: 'themeTan',
  PLUM: 'themePlum',
  BASIC: 'themeBasic',
  TAN_OFFSET: 'themeTanOffset',
};

export const SectionContext = createContext(null);

const Section = forwardRef(
  (
    {
      as: Comp = 'section',
      id,
      heading,
      headingProps,
      children,
      theme = themes.ALTERNATE,
      isInnerOffsetY = false,
      hasSpacer = false,
      spacerSize = 'default',
      ...other
    },
    ref
  ) => {
    const classname = classNames(
      styles.container,
      {
        [ styles[ theme ] ]: !!theme,
        [ styles.isInnerOffsetY ]: isInnerOffsetY,
        [ styles.hasSpacer ]: hasSpacer && spacerSize === 'default',
        [ styles.hasSpacerLg ]: hasSpacer && spacerSize === 'lg',
      },
      other.className
    );

    const isWhiteOut =
      theme === themes.NAVY || theme === themes.PLUM;

    return (
      <SectionContext.Provider value={{ isWhiteOut }}>
        <Comp {...other} id={id} className={classname} ref={ref}>
          <div className={styles.inner}>
            {heading && (
              <Type.H2
                {...headingProps}
                className={styles.heading}
                isWhiteOut={isWhiteOut}
              >
                {heading}
              </Type.H2>
            )}
            {children}
          </div>
        </Comp>
      </SectionContext.Provider>
    );
  }
);

export default Section;
